// extracted by mini-css-extract-plugin
export default {"CommingSoon":"CommingSoon_CommingSoon__GdxiS"};